import { NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { isNavItemActive } from '@/constants/user-menu'

const CONTEST_NAV = { to: '/contests', i18nKey: 'nav.contests' } as const

type ContestNavLinkProps = {
  variant?: 'header' | 'drawer'
  onNavigate?: () => void
}

export function ContestNavLink({ variant = 'header', onNavigate }: ContestNavLinkProps) {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const active = isNavItemActive(pathname, CONTEST_NAV)

  return (
    <NavLink
      to={CONTEST_NAV.to}
      onClick={onNavigate}
      className={clsx(
        variant === 'drawer' ? 'portal-drawer-link' : 'portal-nav-link',
        'portal-pill-gold',
        active && 'is-active',
      )}
    >
      <span className="portal-nav-link__text">{t(CONTEST_NAV.i18nKey)}</span>
    </NavLink>
  )
}
